const cities = [
	{
		label: "tallahessee",
		report: {
			music: {
				jazz: 3,
				funk: 3,
				gospel: 3
			},
			culture: {
				art: 3,
				history: 3,
				science: 3
			},
			nature: {
				hiking: 3,
				swimming: 3,
				climbing: 3
			}
		}
	},
	{
		label: "nijmegen",
		report: {
			music: {
				jazz: 3,
				funk: 3,
				gospel: 3
			},
			culture: {
				art: 3,
				history: 3,
				science: 3
			},
			nature: {
				hiking: 3,
				swimming: 3,
				climbing: 3
			}
		}
	},
	{
		label: "greenville",
		report: {
			music: {
				jazz: 3,
				funk: 3,
				gospel: 3
			},
			culture: {
				art: 3,
				history: 3,
				science: 3
			},
			nature: {
				hiking: 3,
				swimming: 3,
				climbing: 3
			}
		}
	},
]


export default {
	cities,
	cityOptions: cities,
	categories:    [
		{
			label: "music",
			subs: [
				{
					label: "jazz",
				},
				{
					label: "funk",
				},
				{
					label: "gospel",
				}
			]
		},
		{
			label: "culture",
			subs: [
				{
					label: "art",
				},
				{
					label: "history",
				},
				{
					label: "science",
				},
			]
		},
		{
			label: "nature",
			subs: [
				{
					label: "hiking",
				},
				{
					label: "swimming",
				},
				{
					label: "climbing",
				},
			]
		}
	]
}
